import AnimatedBackground from '../../components/AnimatedBackground/AnimatedBackground';
import LoginForm from "./components/LoginForm/LoginForm";

import styles from './login.module.scss';

const Login = () => {
    return (
        <main className={styles.loginWrapper}>
            <AnimatedBackground />
            <LoginForm />
        </main>
    );
};

export default Login;